module.exports = __webpack_public_path__ + "img/date-picker-icon.aafd16b7.svg";